var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      enableBackground: "new 0 0 405.4 251.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B2F20"
    },
    d: "M23.3,101c-1.3,1.9-1.5,4.7-0.2,7c1.1,2,3.4,3.8,5.4,3.4c1.6-0.4,1.4-2,3.4-2.8c2.3-0.9,3.7,1,5.9,0 c1.7-0.8,1.3-2.2,3.1-3.1c2.3-1.1,3.8,0.8,6-0.1c2.2-1,1.4-3.4,3.8-5c2.7-1.8,5,0.2,7.2-1.7c1.7-1.5,0.7-3.2,2.4-5.5 c1.8-2.4,4.1-2.1,6-3.5c4.9-3.5,6.2-16.5-1-23.2c-0.5-0.5-4.4-4-10-3.9c-7.9,0.2-15,7.6-16.4,14.3c-0.4,2.1-0.3,3.7-1.6,6 c-2,3.4-4.2,2.8-6.2,5.9c-2.3,3.6-0.3,6-2.8,8.7C26.3,99.6,24.7,98.9,23.3,101z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.8,
    y1: 1129.9691,
    x2: 368.2,
    y2: 1129.9691,
    gradientTransform: "matrix(1 0 0 1 0 -1010.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M357.5,17.6h-267c-5.9,0-10.7,4.8-10.7,10.7v183c0,5.9,4.8,10.7,10.7,10.7h272 c3.1,0,5.7-2.5,5.7-5.7V28.2C368.1,22.4,363.4,17.6,357.5,17.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "354.2,45.7 95.7,45.7 95.7,45.7 95.7,32.9 354.2,32.9 354.2,32.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M95.7,55v150.2c0,1.6,1.3,3,3,3h252.5c1.6,0,3-1.3,3-3V56.4c0-0.7-0.6-1.3-1.3-1.3L95.7,55 L95.7,55z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494948"
    },
    d: "M348.3,39.3c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S348.3,37.6,348.3,39.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161624419388351069350000016791934638872019127_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.2,
    y1: 1240.6191,
    x2: 384,
    y2: 1240.6191,
    gradientTransform: "matrix(1 0 0 1 0 -1010.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161624419388351069350000016791934638872019127_)"
    },
    d: "M378.2,222H70c-3.2,0-5.8,2.5-5.8,5.7 v1.3c0,5.5,4.5,9.9,10.1,9.9l303.2-0.7c5.6,0,6.5-3.8,6.5-9.2v-1.3C384,224.5,381.5,222,378.2,222z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088099302726212359440000005857017592118978751_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.5,
    y1: -593.1786,
    x2: 396.9,
    y2: -519.7784,
    gradientTransform: "matrix(1 0 0 -1 0 -425.9785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 354.3,
    y: 63,
    style: {
      fill: "url(#SVGID_00000088099302726212359440000005857017592118978751_)"
    },
    width: 11.8,
    height: 135
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M382.4,50.1c0,1.8-1.5,3-3,3v-0.3c0-0.3,0-0.6,0-0.6c0-0.6,0-1.8,0-2.1 C380.3,50.1,381.2,50.1,382.4,50.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005954608131847934580000006519127464147963571_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.7489,
    y1: 1152.2428,
    x2: 67.9438,
    y2: 1105.8195,
    gradientTransform: "matrix(1 0 0 1 0 -1010.7834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7DE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#F7D644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#F6C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#F6A946"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005954608131847934580000006519127464147963571_)"
    },
    d: "M81.7,80.7c-3.4-0.4-7.4-0.4-11.5,0.6 c-2.5,0.6-4.7,1.5-4.7,1.5c-1.7,0.8-3.2,1.5-3.2,1.5c-0.3,0.6-1,1.6-2.7,2.6c-1.3,0.8-2.3,0.9-3,1c-1,0.5-3.3,2.1-4.1,4 c-0.6,1.4-0.1,2.5,0,3.3c1.1,8.9,7.8,11.6,7.8,11.6c5.8,9.3,19.7,26.8,20.5,22.7C82.8,119.6,81.7,80.7,81.7,80.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088816228182196960520000004144521106187071389_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.2896,
    y1: 1138.653,
    x2: 76.1841,
    y2: 1158.0308,
    gradientTransform: "matrix(1 0 0 1 0 -1010.7834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088816228182196960520000004144521106187071389_)"
    },
    d: "M72.7,122.5c-2,12.6,9,31,9,31l0.2-38.1 L72.7,122.5L72.7,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M54.5,80.3c0.7,2.5,1.4,5.1,2.1,7.6c0.8,0,2.6-0.2,4.3-1.5c1-0.8,1.6-1.6,2-2.2 c-0.8-2-1.6-4-2.4-6.1c-2.2,0-4.3,0-6.5,0C54.2,78.8,54.3,79.5,54.5,80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F68D61"
    },
    d: "M61,78.6l-1.6-0.5H59h-0.2l-2,1.2L56.7,81c0.2,0.3,1.1,1.6,2.8,2.1c1.2,0.3,2.2,0.4,3,0.1 c-0.5-1.6-0.9-3.4-1.4-4.9L61,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M60.9,66.7c0.5,1.1,1.4,3.6,1.6,4.2c0.2,0.8,0.4,1.1,0.6,1.9c0.8,2.7,1,2.7,1.3,4 c0.5,2.1,0.8,3.2,0.2,4.1c-0.7,0.9-2,1-4,1.1c-1.4,0.1-2.4,0.1-3.6-0.5c-1.3-0.7-2-1.8-2.3-2.3c0,0-0.1,0.8-0.7,0.5 c-0.6-0.3-2.8-3.2-1.7-3.7c1.1-0.6,2.1,0.9,2.1,0.9l0.6-1C55.2,75.8,54.6,63.3,60.9,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M62.3,77.2c0.4,1,1.5,1.5,2.5,1.1c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.4-0.2-0.9-0.3-1.4L62.3,77.2 L62.3,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80.3,80.6c1.2,0,2.4,0,3.6,0c0.4,0,0.8-0.4,0.7-0.8c0-0.3-0.4-0.6-0.7-0.6l-3.6-0.4 C79.5,79.8,80.3,80.6,80.3,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80,82.3c1.2,0.1,2.3,0.1,3.4,0.2c0.5,0.1,0.9-0.3,0.9-0.7c0-0.3-0.2-0.6-0.6-0.7 c-1.2-0.2-2.3-0.3-3.5-0.5C79.4,81.4,80.1,82.3,80,82.3L80,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M79.8,83.8c1,0.1,2,0.2,3.2,0.2c0.3-0.1,0.5-0.3,0.6-0.6c0.1-0.3-0.1-0.6-0.3-0.7L80,82.3 C79.5,82.8,79.6,83.4,79.8,83.8L79.8,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80.3,78.8l3.7-0.2c0.4,0,0.6-0.3,0.6-0.7c0-0.4-0.3-0.7-0.7-0.7c-1.2,0-2.4-0.1-3.6-0.1 C79.7,78.1,80.3,78.8,80.3,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M82.8,123.6c-0.1-0.1-1.5-1-2.7-0.4c-0.3,0.2-0.6,0.4-0.7,0.6l-1.2-0.2l-1.1,4.9 c0.5-0.1,1-0.2,1.5-0.2c0,0.3,0.1,0.5,0.2,0.7c0.6,1,2.5,1.1,4.9,0.5C83.5,127.4,83.2,125.5,82.8,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F68D61"
    },
    d: "M82.8,123.6c-0.1-0.1-1.5-1-2.7-0.4l0,0c-0.1,0.8,0,1.2,0,1.2s-0.5,0.9,0.1,1.6c0,0-0.8,1.1-0.1,2.2 c0,0-0.3,0.8-0.2,1.4c0.9,0.3,2.3,0.2,3.9-0.2C83.5,127.4,83.2,125.5,82.8,123.6L82.8,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M81.4,126.7l4.3-0.3c0.5-0.1,0.9-0.6,0.8-1s-0.5-0.7-1-0.7l-4.4-0.1 C80.2,125.9,81.3,126.7,81.4,126.7L81.4,126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M81.2,128.8c1.4,0,2.8-0.1,4.1-0.1c0.6,0,1-0.4,1-0.9c0-0.4-0.3-0.7-0.8-0.8l-4.2-0.3 C80.3,127.7,81.2,128.8,81.2,128.8L81.2,128.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M81,130.6c1.2,0,2.5,0,3.9,0c0.3-0.1,0.6-0.4,0.6-0.7s-0.1-0.7-0.4-0.8c-1.3-0.1-2.6-0.1-3.9-0.2 C80.6,129.5,80.8,130.2,81,130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M81.2,124.6c1.5-0.2,2.9-0.4,4.3-0.6c0.4-0.1,0.7-0.5,0.7-0.9c0-0.5-0.4-0.8-0.9-0.8 c-1.5,0.1-2.9,0.2-4.3,0.2C80.4,123.8,81.2,124.6,81.2,124.6L81.2,124.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091723048402350159080000009178090429087776446_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.4696,
    y1: 1150.8781,
    x2: 60.8285,
    y2: 1105.9335,
    gradientTransform: "matrix(1 0 0 1 0 -1010.7834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7DE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#F7D644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#F6C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#F6A946"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091723048402350159080000009178090429087776446_)"
    },
    d: "M59.2,127.8c-5.9-3-8.6-8.3-9.5-11.2 c-2.7-8-1.6-20.1,1.3-24.1c1.5-2.1,3-3,4.3-3.8c-0.4,2.4,0.3,5.9,0.9,9.9c0.8,6.2,2.2,1.7,3.9,4.2c0.3,1.7,2,13.2,4,15.1 c1.9,1.8,12.9,4.2,14.5,4.5v7.5C76.3,130.4,63.4,129.9,59.2,127.8L59.2,127.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172408700803011993880000017503446517864970672_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.125,
    y1: 857.575,
    x2: 240.375,
    y2: 889.825,
    gradientTransform: "matrix(1 0 0 1 0 -688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172408700803011993880000017503446517864970672_)"
    },
    d: "M240.3,201.8h-32.2v-32.2h32.3 L240.3,201.8L240.3,201.8z M211.1,198.8h26.3v-26.2h-26.3V198.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062885782630457748410000006499162298490526095_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.6616,
    y1: 866.8115,
    x2: 228.7751,
    y2: 874.925,
    gradientTransform: "matrix(1 0 0 1 0 -688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000062885782630457748410000006499162298490526095_)"
    },
    points: "223.3,192.4 215.3,184.1  217.5,182.1 223.2,188 231.4,178.8 233.6,180.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075868663519120275260000009409161929306181558_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.7556,
    y1: -988.9457,
    x2: 210.5797,
    y2: -988.9457,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    style: {
      stopColor: "#E6E9DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D8DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075868663519120275260000009409161929306181558_)"
    },
    d: "M190.3,9L257,8.9l0.3,97.9l-66.7,0.1 L190.3,9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022546114471560999050000017048991483758721410_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.0274,
    y1: -949.7682,
    x2: 198.9766,
    y2: -949.7682,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7DE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#F7D644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#F6C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#F6A946"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022546114471560999050000017048991483758721410_)"
    },
    d: "M243.6,20.5l-14.3-0.2l-0.4-3.4l14.3,0.2 l2.2,2L243.6,20.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166652530258866506660000005932309646398028683_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.1973,
    y1: -950.7439,
    x2: 185.1465,
    y2: -950.7439,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166652530258866506660000005932309646398028683_)"
    },
    d: "M230.1,21.5l-14.3-0.2l-0.4-3.4l14.3,0.2 l2.2,2L230.1,21.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054968709202272211570000007726019379676125574_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.3354,
    y1: -950.5181,
    x2: 171.2845,
    y2: -950.5181,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054968709202272211570000007726019379676125574_)"
    },
    d: "M215.7,21.3l-14.3-0.2l-0.4-3.4l14.3,0.2 l1.5,2L215.7,21.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#283757",
      enableBackground: "new"
    },
    d: "M229.4,73.8l-11.2-5.6L207,70.9l0.1-0.8l11.3-2.7 L229.4,73.8l11.4-3.7l0.8,0.9L229.4,73.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160895901795166183330000011983990809692881307_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.9384,
    y1: -1001.9141,
    x2: 161.7677,
    y2: -1001.9141,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000160895901795166183330000011983990809692881307_)"
    },
    cx: 206.2,
    cy: 70.9,
    r: 1.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031921824322040987110000004516328015409253307_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.4754,
    y1: -998.4362,
    x2: 173.3006,
    y2: -998.4362,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7DE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#F7D644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#F6C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#F6A946"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000031921824322040987110000004516328015409253307_)"
    },
    cx: 218.5,
    cy: 67.4,
    r: 1.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042010894544662920090000011101847077482730157_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.0105,
    y1: -1004.8557,
    x2: 184.8364,
    y2: -1004.8557,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000042010894544662920090000011101847077482730157_)"
    },
    cx: 229.4,
    cy: 73.8,
    r: 1.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034793850034522229520000014772758386575412362_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.5421,
    y1: -1001.1765,
    x2: 196.3714,
    y2: -1001.1765,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000034793850034522229520000014772758386575412362_)"
    },
    cx: 241,
    cy: 70.1,
    r: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096029818269343818830000017586610685301889161_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.3354,
    y1: -1011.6078,
    x2: 167.5532,
    y2: -1011.6078,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096029818269343818830000017586610685301889161_)"
    },
    d: "M211.9,79.1h-6.7c-1.6-0.1-2.7,1.4-2,2.2 l-0.1,0.8L215,82l0.1-0.8C214.2,80.3,212.7,79.1,211.9,79.1z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.37
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97,
      fill: "#283757",
      enableBackground: "new"
    },
    d: "M212,86h-6.7l-0.8-0.1l0.1-0.8L212,86 C212,85.2,212,86,212,86C212.8,86,212,86,212,86z M211.8,87.5h-6.7l-0.8-0.1l0.1-0.8L211.8,87.5 C211.8,86.8,211.8,87.5,211.8,87.5C212.6,87.7,211.8,87.5,211.8,87.5z M211.4,90h-6.7l-0.8-0.1l0.1-0.8L211.4,90 C212.4,89.3,212.4,89.3,211.4,90C212.4,89.3,212.2,90.1,211.4,90z M212.1,91l-7.5-0.1c0,0,0,0-0.8-0.1l0,0c0,0,0,0,0.1-0.8 l7.5,0.1C212.2,90.1,212.2,90.1,212.1,91L212.1,91L212.1,91z M211.7,95.1H205l-0.8-0.1l0.1-0.8L211.7,95.1 C211.7,94.3,211.7,95.1,211.7,95.1C212.5,95.3,211.7,95.1,211.7,95.1z M208.9,96.5l-5.1,0.3l-0.8-0.1l0.1-0.8L208.9,96.5 C210,95.7,209.7,96.6,208.9,96.5C209.7,96.6,208.9,96.5,208.9,96.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170983131566245187120000012558861720877740710_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.045,
    y1: -1011.7991,
    x2: 183.267,
    y2: -1011.7991,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170983131566245187120000012558861720877740710_)"
    },
    d: "M227.2,79.3h-6.7 c-1.6-0.1-2.7,1.4-2,2.2l-0.1,0.8l11.9-0.2l0.1-0.8C230.4,80.5,228.9,78.8,227.2,79.3z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.37
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97,
      fill: "#283757",
      enableBackground: "new"
    },
    d: "M227.9,86.2l-7.5-0.1l-0.8-0.1l0.1-0.8L227.9,86.2 C228,85.4,228,85.4,227.9,86.2L227.9,86.2z M227.5,89.5h-6.7l-0.8-0.1l0.1-0.8L227.5,89.5C228.5,88.9,228.3,89.7,227.5,89.5 L227.5,89.5z M227.3,91.3l-7.5-0.1c0,0,0,0-0.8-0.1l0,0c0,0,0,0,0.1-0.8l7.5,0.1C228.3,90.5,228.3,90.5,227.3,91.3L227.3,91.3 C228.1,91.3,227.3,91.3,227.3,91.3z M227.9,92.9h-6.7l-0.8-0.1l0.1-0.8L227.9,92.9C228,92.1,227.9,92.9,227.9,92.9L227.9,92.9z  M227.6,95.5h-6.7l-0.8-0.1l0.1-0.8L227.6,95.5C227.8,94.7,227.8,94.7,227.6,95.5L227.6,95.5z M225.9,96.8H220l-0.8-0.1l0.1-0.8 L225.9,96.8C226.7,96.3,226.7,96.3,225.9,96.8C226.6,97.1,226.6,97.1,225.9,96.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098928728938138829480000003758003918579434647_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.7586,
    y1: -1011.264,
    x2: 198.9766,
    y2: -1011.264,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7DE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#F7D644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#F6C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#F6A946"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098928728938138829480000003758003918579434647_)"
    },
    d: "M243.2,78.7h-6.7 c-1.6-0.1-2.7,1.4-2,2.2l-0.1,0.8l11.9-0.2l0.1-0.8C245.6,79.9,244.8,79.1,243.2,78.7z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.37
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97,
      fill: "#283757",
      enableBackground: "new"
    },
    d: "M239.7,86l-4.2,0.3l-0.8-0.1l0.1-0.8L239.7,86 C240,85.2,239.7,86,239.7,86S240.5,86.1,239.7,86z M243,88.1h-6.7l-0.8-0.1l0.1-0.8L243,88.1C243.8,87.3,243.8,87.3,243,88.1 C243.8,87.3,243,88.1,243,88.1z M243.6,89.9h-6.7l-0.8-0.1l0.1-0.8L243.6,89.9C243.6,89.1,243.6,89.1,243.6,89.9L243.6,89.9z  M243.2,91.5l-7.5-0.1c0,0,0,0-0.8-0.1l0,0c0,0,0,0,0.1-0.8l7.5,0.1C243.6,89.9,243.6,89.9,243.2,91.5L243.2,91.5L243.2,91.5z  M243.1,93.3h-6.7l-0.8-0.1l0.1-0.8L243.1,93.3C244.1,92.4,244.1,92.4,243.1,93.3C243.9,93.3,243.1,93.3,243.1,93.3z  M243.5,96.6l-7.5-0.1l-0.8-0.1l0.1-0.8L243.5,96.6C243.7,95.8,243.5,96.6,243.5,96.6L243.5,96.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139251300997589964230000017631952128771201703_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.004,
    y1: -983.5705,
    x2: 198.9766,
    y2: -983.5705,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139251300997589964230000017631952128771201703_)"
    },
    d: "M231.2,53.7l13.5,0.1 c0.8,0.1,0.9-0.8,0.9-1.6c0.1-0.8-0.8-0.9-1.6-0.9l-13.5-0.1c-0.8-0.1-0.9,0.8-0.9,1.6C229.6,52.7,230.4,53.6,231.2,53.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031900862127745534270000007357233189960875690_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.004,
    y1: -983.5705,
    x2: 198.9766,
    y2: -983.5705,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031900862127745534270000007357233189960875690_)"
    },
    d: "M231.2,53.7l13.5,0.1 c0.8,0.1,0.9-0.8,0.9-1.6c0.1-0.8-0.8-0.9-1.6-0.9l-13.5-0.1c-0.8-0.1-0.9,0.8-0.9,1.6C229.6,52.7,230.4,53.6,231.2,53.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176035735801603312250000009731219916046932364_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.0068,
    y1: -987.2263,
    x2: 198.9766,
    y2: -987.2263,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176035735801603312250000009731219916046932364_)"
    },
    d: "M236.6,56.9l8.4,0.2l0.9-0.8l0,0 l-0.8-0.9l-8.4-0.2l-0.8,0.8l0,0C235.8,56.8,236.6,56.9,236.6,56.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103965971524126302370000007881572798400973998_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.9779,
    y1: -990.5294,
    x2: 198.9766,
    y2: -990.5294,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7DE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#F7D644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#F6C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#F6A946"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103965971524126302370000007881572798400973998_)"
    },
    d: "M241.2,60.9l3.4-0.4 c0.8,0.1,0.9-0.8,0.9-1.6c0.1-0.8-0.8-0.9-1.6-0.9l-3.4,0.4c-0.8-0.1-0.9,0.8-0.9,1.6C239.6,60.7,240.4,60.7,241.2,60.9z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.37
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97,
      fill: "#283757",
      enableBackground: "new"
    },
    d: "M224.6,52l-20.2,0.1l-0.8-0.1l0.1-0.8L224.6,52 C225.6,51.2,225.4,52.1,224.6,52C225.4,52.1,225.4,52.1,224.6,52z M225.3,53.7l-21.8-0.3l-0.8-0.1l0.1-0.8L225.3,53.7 C225.3,52.9,225.3,53.7,225.3,53.7L225.3,53.7z M224.8,57.9L204.5,58l-0.8-0.1l0.1-0.8L224.8,57.9 C225.7,57.1,225.7,57.1,224.8,57.9C225.7,57.1,225.5,58.2,224.8,57.9z M224.5,59.5l-21.8-0.3l-0.8-0.1l0.1-0.8L224.5,59.5 C225.5,59,225.5,59,224.5,59.5C225.3,59.8,225.3,59.8,224.5,59.5z M210.8,61.3l-8.4-0.2l-0.8-0.1l0.1-0.8L210.8,61.3 C211.7,60.5,211.6,61.3,210.8,61.3C211.6,61.3,211.6,61.3,210.8,61.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047020857532598604560000000462849733443859873_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.3354,
    y1: -965.9775,
    x2: 164.8106,
    y2: -965.9775,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AEDC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#63DBC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#6BCEC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DC9C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047020857532598604560000000462849733443859873_)"
    },
    d: "M209,34.9c0.1-1.6,1.2-2.4,2.9-3v-6.7 c-5.1,0.3-9.8,4.6-9.6,9.9c0.3,5.1,4.6,9.8,9.9,9.6V38C209.6,37.5,208.9,35.7,209,34.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116193099761602080670000009441257939137425598_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.8106,
    y1: -959.9609,
    x2: 172.8925,
    y2: -959.9609,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7DE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#F7D644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#F6C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#F6A946"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116193099761602080670000009441257939137425598_)"
    },
    d: "M213.5,32.9l5.5-3.5 c-1.4-2.7-4.5-4.7-7.8-4.4v6.7C211.9,31.8,213.6,32.1,213.5,32.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016798339247200170450000012553052073240603834_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.8106,
    y1: -967.73,
    x2: 174.2861,
    y2: -967.73,
    gradientTransform: "matrix(1 -1.795990e-03 -1.795990e-03 -1 44.8562 -930.7275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016798339247200170450000012553052073240603834_)"
    },
    d: "M220.8,34.6c0.1-1.6-0.4-3.4-1.9-5.4 l-5.5,3.5c0.8,0.1,0.8,0.9,0.7,1.8c-0.1,1.6-1.2,2.4-2.9,3v6.7C216.4,44.2,221.1,39.7,220.8,34.6z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.37
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97,
      fill: "#283757",
      enableBackground: "new"
    },
    d: "M245.4,27.6l-16-0.3l-0.8-0.1l0.1-0.8L245.4,27.6 C245.5,26.7,245.4,27.6,245.4,27.6L245.4,27.6z M245.1,29.3l-17.7,0.2l-0.8-0.1l0.1-0.8L245.1,29.3 C245.4,28.4,245.9,29.3,245.1,29.3C245.9,29.3,245.1,29.3,245.1,29.3z M244.9,31.7l-17.7,0.2l-0.8-0.1l0.1-0.8L244.9,31.7 C245.8,31,245.8,31,244.9,31.7L244.9,31.7z M245.4,33.4l-17.7,0.2l-0.8-0.1l0.1-0.8L245.4,33.4C245.7,32.6,245.7,32.6,245.4,33.4 L245.4,33.4z M244.5,35l-16.9,0.5c0,0,0,0-0.8-0.1l0,0c0,0,0,0,0.1-0.8l16.9-0.5C244.6,34.2,244.6,34.2,244.5,35L244.5,35 L244.5,35z M244.9,38.4l-16-0.3l-0.8-0.1l0.1-0.8L244.9,38.4C245.8,37.9,245.7,38.6,244.9,38.4C245.7,38.6,244.9,38.4,244.9,38.4 z M245.6,40.2l-17.7,0.2l-0.8-0.1l0.1-0.8L245.6,40.2C245.6,39.4,245.6,40.2,245.6,40.2L245.6,40.2z M240.1,43l-11.9,0.2 l-0.8-0.1l0.1-0.8L240.1,43C240.2,42.1,240.2,42.1,240.1,43L240.1,43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEBFCA"
    },
    d: "M196,166.6l7.3-59.1l1.6,0.1l-7.3,59.1L196,166.6z M250,166.7l-7.8-59.3l1.6,0.1l7.8,59.3 L250,166.7z M222.8,107.5l1.6,0.1v54.8l-1.6-0.1V107.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A3756"
    },
    d: "M211.6,7.3L237,7.2l-0.1,1.6l-25.4,0.1L211.6,7.3z M198.2,108.6l0.1-1.6l53.2-0.1l-0.1,1.6"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134944176222514890800000008250597321021392256_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.4761,
    y1: 815.2785,
    x2: 74.6565,
    y2: 803.1588,
    gradientTransform: "matrix(-1 0 0 1 193.1681 -683.213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134944176222514890800000008250597321021392256_)"
    },
    points: "109.5,139.2 107.6,136.9  119.4,127.3 107,118.4 108.7,116 124.4,127.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109003368886967734050000006886778166404326022_",
    gradientUnits: "userSpaceOnUse",
    x1: -128.0133,
    y1: 815.2872,
    x2: -142.8323,
    y2: 803.1679,
    gradientTransform: "matrix(-1 0 0 1 193.1681 -683.213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000109003368886967734050000006886778166404326022_)"
    },
    points: "327,139.2 325.1,136.9  336.9,127.3 324.4,118.4 326.2,116 341.9,127.1  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.3069bddc.svg";
export { ForwardRef as ReactComponent };